export default "__VITE_ASSET__BLXOagv8__"